import axios from 'axios';
import toast from 'react-hot-toast';

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const detail = error.response?.data?.detail;

    if (status === 429) {
      toast.error(detail || 'The AI service is rate-limited. Please wait a moment and try again.');
    } else if (status === 503) {
      toast.error(detail || 'The AI service is temporarily unavailable. Please try again shortly.');
    } else if (!error.response) {
      toast.error('Network error. Please check your connection and try again.');
    }

    return Promise.reject(error);
  }
);
